import { render } from "./accordion.components.vue?vue&type=template&id=65b1b7dc&ts=true"
import script from "./accordion.components.vue?vue&type=script&lang=ts"
export * from "./accordion.components.vue?vue&type=script&lang=ts"

import exportComponent from "/home/seb/_git-wsl/inv-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__